var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend__wrapper"},_vm._l((_vm.colorKeys),function(color){return _c('ColorLegend',{key:color,attrs:{"attackType":color,"bgColor":_vm.colors[color]}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }